import { useIntl } from 'react-intl';

import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import Body from 'iovisit-ferraraterraeacqua/components/Blocks/Prenotazioni/Components/Body';

const Edit = (props) => {
  const intl = useIntl();
  const { selected, blocksConfig, onChangeBlock, block, data } = props;

  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });

  return (
    <div className="block prenotazioni">
      {/* <Body isEditMode data={data} /> */}
      <Body data={data} />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          {...props}
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
